import { EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { Socket } from 'ngx-socket-io';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { SwPush } from '@angular/service-worker';
import { HttpClient } from '@angular/common/http';
import { LocalService } from './local.service';
import * as i0 from "@angular/core";
import * as i1 from "./auth.service";
import * as i2 from "@angular/service-worker";
import * as i3 from "@angular/common/http";
import * as i4 from "./local.service";
var SysnotificationService = /** @class */ (function () {
    function SysnotificationService(auth, swPush, http, localService) {
        this.auth = auth;
        this.swPush = swPush;
        this.http = http;
        this.localService = localService;
        this.activeSessionEmitter = new EventEmitter();
        this._subject = new Subject();
        this.messageBeep = new Audio('../../assets/audio/message-beep.mp3');
        this.publicVapid = environment.vapidKey;
        this.initSettings();
    }
    Object.defineProperty(SysnotificationService.prototype, "socketConfig", {
        /**
         * socketConfig
         * return setting object
         */
        get: function () {
            return {
                url: environment.socketsURL + "/notifications",
                options: {
                    transports: ['websocket'],
                    reconnection: true,
                    autoConnect: true
                }
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SysnotificationService.prototype, "activeAudioStatus", {
        get: function () {
            return this.localService.getJsonValue('userData').activeAudio;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SysnotificationService.prototype, "activeNotifications", {
        get: function () {
            return this.localService.getJsonValue('userData').activeNotifications;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * socketInit
     * connect to company notification socket and enable the audio listener.
     */
    SysnotificationService.prototype.socketInit = function () {
        var _this = this;
        this.notificationSocket = new Socket(this.socketConfig);
        this.companyId = this.auth.user.company.id;
        this.notificationSocket.on('connect', function () {
            _this.emit('joinRoom', "" + _this.auth.user.id);
        });
        this.listen('audio').subscribe(function () { _this.playMessageBeep(); });
    };
    /**
     * emit
     * emit socket event
     * @param eventName
     */
    SysnotificationService.prototype.emit = function (eventName, message) {
        if (this.notificationSocket)
            this.notificationSocket.emit(eventName, message);
    };
    /**
     * listen
     * listen socket event
     * @param event
     */
    SysnotificationService.prototype.listen = function (event) {
        var _this = this;
        if (this.notificationSocket) {
            return new Observable(function (subscriber) {
                _this.notificationSocket.on(event, function (data) { subscriber.next(data); });
            });
        }
    };
    /**
     * initSettingss
     * Validate if the user has audio notifications enabled,
     * and also initialize the subscription with push notifications.
     */
    SysnotificationService.prototype.initSettings = function () {
        if (this.localService.getJsonValue('userData').activeAudio === undefined) {
            this.auth.user.activeAudio = true;
            this.localService.setJsonValue('userData', this.auth.user);
        }
        this.socketInit();
        this.initPushNotification();
        this.initNotificationClickListener();
    };
    /**
     * initNotificationClickListener
     * Al hacer clic en una notificación push del navegador, navega a conversaciones.
     */
    SysnotificationService.prototype.initNotificationClickListener = function () {
        this.swPush.notificationClicks.subscribe(function (_a) {
            var action = _a.action, notification = _a.notification;
            window.open(window.location.origin + "/admin/conversations", '_self');
        });
    };
    /**
     * playMessageBeep
     * emit the sound notification when contact send new message
     */
    SysnotificationService.prototype.playMessageBeep = function () {
        var _this = this;
        if (this.localService.getJsonValue('userData').activeAudio) {
            this.messageBeep.preload = "auto";
            this.messageBeep.autoplay = true;
            this.messageBeep.play().catch(function (error) { _this.requestAutoplayPermission(error); });
        }
    };
    /**
     * requestAutoplayPermission
     * Display an alert notifying that audio notifications need to be enabled.
     */
    SysnotificationService.prototype.requestAutoplayPermission = function (error) {
        console.error(error);
    };
    /**
     * initPushNotification
     * Initiate the subscription and generate the push token for the user.
     */
    SysnotificationService.prototype.initPushNotification = function () {
        var _this = this;
        this.localService.removeJsonValue('authToken');
        this.swPush.requestSubscription({
            serverPublicKey: this.publicVapid
        }).then(function (sub) {
            var token = JSON.parse(JSON.stringify(sub));
            if (token && token.keys) {
                _this.localService.setJsonValue('authToken', token.keys.auth);
                _this.addPushToken({ auth: token.keys.auth, token: token }).subscribe();
            }
        }).catch(function (error) { console.error('Error requesting push notification subscription:', error); });
    };
    /**
     * addPushToken
     * Event that adds the user token to the database.
     * @param token
     * @returns Observable<any>
     */
    SysnotificationService.prototype.addPushToken = function (_a) {
        var auth = _a.auth, token = _a.token;
        var sendURL = environment.baseServerURL + "/security/user/pushToken";
        var pushToken = {
            user_id: this.auth.user.id,
            auth: auth,
            pushToken: JSON.stringify(token),
            activeSession: 1
        };
        return this.http.post(sendURL, pushToken, { withCredentials: true });
    };
    /**
     * changeNotificationStatus
     * Change the push notification status for the user,
     * which disables the display of push notifications.
     * @param { userId, status }
     * @returns
     */
    SysnotificationService.prototype.changeNotificationStatus = function (_a) {
        var userId = _a.userId, status = _a.status;
        var sendURL = environment.baseServerURL + "/security/user/changeNotificationStatus/" + userId;
        this.auth.user.activeNotifications = status;
        this.localService.setJsonValue('userData', this.auth.user);
        return this.http.patch(sendURL, { status: status }, { withCredentials: true });
    };
    /**
     * changeActiveSession   *
     * @param { auth, status }
     * @returns
     */
    SysnotificationService.prototype.changeActiveSession = function (_a) {
        var auth = _a.auth, status = _a.status;
        var sendURL = environment.baseServerURL + "/security/user/changeActiveSession/" + auth;
        return this.http.patch(sendURL, { status: status }, { withCredentials: true });
    };
    /**
     * setFocused
     * Disable the display of push notifications if the user is located in the active tab.
     * @param { userId, status }
     */
    SysnotificationService.prototype.setFocused = function (status) {
        if (this.auth.user.activeNotifications === 1)
            this.emit('window_focused', { auth: this.localService.getJsonValue('authToken'), status: status });
    };
    /**
     * changeAudioStatus
     * Change the status of audio notifications.
     * @param status
     */
    SysnotificationService.prototype.changeAudioStatus = function (status) {
        this.auth.user.activeAudio = status;
        this.localService.setJsonValue('userData', this.auth.user);
    };
    /**
     * getObservable : ⚠️ Deprecated
     * return subject to Trobbit notifications
     */
    SysnotificationService.prototype.getObservable = function () {
        return this._subject.asObservable();
    };
    SysnotificationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SysnotificationService_Factory() { return new SysnotificationService(i0.ɵɵinject(i1.AuthService), i0.ɵɵinject(i2.SwPush), i0.ɵɵinject(i3.HttpClient), i0.ɵɵinject(i4.LocalService)); }, token: SysnotificationService, providedIn: "root" });
    return SysnotificationService;
}());
export { SysnotificationService };
